import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import bootstrap from "bootstrap";
import bootsrap from "bootstrap/dist/css/bootstrap.css"

createApp(App).use(store).use(router).mount('#app')
